import { getDateValueInTimeZone } from "Components/Generic/MilestoneDates";
import { format } from "date-fns";
import { getHoursMinutesBySeconds, normalizeTime } from "./timeControl";


export const formatSimpleDate = (
  date: string | Date,
  options: { formatString?: string; isUTC?: boolean } = {}
) => {
  const { formatString = "dd/MM/yyyy", isUTC } = options;

  if (date instanceof Date) date = date.toISOString();
  const dateWithTimezone = isUTC ? date : getDateValueInTimeZone(date)!;

  return format(new Date(dateWithTimezone), formatString);
};

export const formatSimpleTime = (
  date: string,
  options: { isUTC?: boolean; formatString?: string } = {}
) => {
  const { isUTC, formatString = "HH:mm" } = options;
  const dateWithTimezone = isUTC ? date : getDateValueInTimeZone(date)!;

  return format(new Date(dateWithTimezone), formatString);
};

export const getHoursDiffering = (left: Date, right: Date) => {
  const leavingWarehouseDate = new Date(left).setSeconds(0, 0);
  const arriveResidenceDate = new Date(right).setSeconds(0, 0);
  const diffTransitTime = arriveResidenceDate - leavingWarehouseDate;
  const { hours, minutes } = getHoursMinutesBySeconds(diffTransitTime);

  return `${normalizeTime(hours, 2)}:${normalizeTime(minutes, 2)}`;
};
